import React from 'react';
import { content } from '../data/content';
import { motion } from 'framer-motion';
import Button from '../components/Button';

const CTASection = () => {
  return (
    <section className="py-24 px-4">
      <div className="container-custom">
        <div className="bg-primary rounded-[3rem] p-12 lg:p-24 text-center text-white relative overflow-hidden shadow-2xl shadow-primary/20">
          {/* Animated Background Gradients */}
          <div className="absolute top-0 left-0 w-full h-full opacity-20 pointer-events-none">
            <div className="absolute -top-1/2 -left-1/4 w-[1000px] h-[1000px] bg-[radial-gradient(circle,_rgba(255,255,255,0.4)_0%,_transparent_70%)] animate-pulse" />
          </div>

          <div className="relative z-10 max-w-3xl mx-auto">
            <motion.h2
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              className="text-4xl lg:text-7xl font-display font-bold mb-8 leading-tight"
            >
              Let's Build Something Amazing <span className="bg-primary-light/30 px-4 rounded-2xl">Together</span>
            </motion.h2>
            <p className="text-xl text-white/80 mb-12 max-w-2xl mx-auto leading-relaxed">
              {content.ctaBox.subtitle}
            </p>
            <div className="flex flex-wrap justify-center gap-6">
              <a href='/contact'><Button variant="outline" className="px-10 py-4 bg-white/10 hover:bg-white text-white hover:text-white border-white/20 text-lg">
                {content.ctaBox.button1}
              </Button></a>
              {/* <Button variant="outline" className="px-10 py-4 border-white text-white hover:bg-white/10 text-lg">
                {content.ctaBox.button2}
              </Button> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
